<script setup lang="ts">
withDefaults(defineProps<{
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  align?: 'left' | 'center' | 'right'
}>(), {
  as: 'h2',
  align: 'left'
})
</script>

<template>
  <component :is="as" class="section-title" :class="`section-title-${align}`">
    <span class="section-title-text"><slot /></span>
  </component>
</template>

<style scoped>
.section-title {
  width: 100%;
  margin: 12px 0;
  color: var(--text);
  font-size: 26px;
  text-align: left;
  scroll-margin-top: var(--anchor-offset);
}

.section-title-center {
  text-align: center;
}

.section-title-right {
  text-align: right;
}

.section-title-text {
  position: relative;
  isolation: isolate;
  display: inline-block;
  max-width: 100%;
  padding-left: 0.7em;
  vertical-align: top;
}

.section-title-text::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 50%;
  left: 0;
  width: 2.5em;
  height: 2.5em;
  transform: translateY(-50%);
  border-radius: 50%;
  background: linear-gradient(to bottom, color-mix(in srgb, var(--brand) 20%, transparent), transparent);
  pointer-events: none;
}
</style>
